import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Divider, `.dsk-divider`.
 *
 * Source selector: `system.css` `.dsk-divider`.
 *
 * Renders a real `<hr>`, so it carries the separator role natively rather than
 * needing a `role="separator"` bolted onto a styled `<div>`.
 *
 * Doctrine enforced: the rule is `--ds-hairline-soft`, the quieter of the two
 * hairlines, because a divider inside a card is separating regions of one
 * surface, not two surfaces.
 */
export const Divider = React.forwardRef(function Divider({ className, ...rest }, ref) {
  return <hr ref={ref} className={cn('dsk-divider', className)} {...rest} />;
});
Divider.displayName = 'Divider';

export default Divider;
